export default __webpack_public_path__ + "static/media/Silicon shoe.8ecfef27.png";